import { HallmarkMembershipStatus, InitializationData } from '../../global-types';
import { actionTypes, Dispatch } from './data-context-types';

export const setInitializationData = (dispatch: Dispatch, initData: InitializationData) => {
  dispatch({
    type: actionTypes.SET_INIT_DATA,
    payload: initData,
  });
};

export const setLineItemUUID = (dispatch: Dispatch, UUID: string) => {
  dispatch({
    type: actionTypes.SET_LINE_ITEM_UUID,
    payload: UUID,
  });
};

export const updateProjectName = (dispatch: Dispatch, projectName: string) => {
  dispatch({
    type: actionTypes.UPDATE_PROJECT_NAME,
    payload: projectName,
  });
};

export const setMembershipStatus = (dispatch: Dispatch, membershipStatus: HallmarkMembershipStatus) => {
  dispatch({
    type: actionTypes.SET_MEMBERSHIP_STATUS,
    payload: membershipStatus,
  });
};
